**Deprecated:** Use `hiringOrganization` instead.
